import axios from '../utils/http'

// 登录
export const loginPost = (data) =>
  axios({
    url: '/jeecg-boot/sys/login',
    method: 'post',
    data
  })

// 手机号登录
export const loginPhonePost = (data) =>
  axios({
    url: '/jeecg-boot/sys/phoneLogin',
    method: 'post',
    data
  })

// 获取验证码
export const loginPhoneRandomImagePost = (data) =>
  axios({
    url: `/jeecg-boot/sys/randomImage/${data}`,
    method: 'get',
  })


// 首页数据表单
export const instrumentHomeGet = (params) =>
  axios({
    url: '/jeecg-boot/shuangpang/userhomeOrder/index',
    method: 'get',
    params 
  })

  // 首页最新活动点击已读
  export const instrumentHomeReadyPost = (params) =>
  axios({
    url: '/jeecg-boot/shuangpang/userhomeOrder/ready',
    method: 'post',
    params
  })